import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../config';

export const checkAllowedUser = async (email: string): Promise<boolean> => {
  const allowedUsersRef = collection(firestore, 'allowedUsers');
  const q = query(allowedUsersRef, where('email', '==', email));
  const snapshot = await getDocs(q);
  return !snapshot.empty;
};